module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._m(2), " ", _vm._h('hello')])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('h1', {
    staticClass: "title"
  }, ["Vue-progressbar"])
},function (){var _vm=this;
  return _vm._h('h3', {
    staticClass: "sub title"
  }, ["A robust progress bar for VueJS 2.0"])
},function (){var _vm=this;
  return _vm._h('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-308c8ee7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 2